import React, { useContext, useState } from "react";
import { createUseStyles } from "react-jss";
import _ from "lodash";
import jssVariables, { mainMenuBtn } from "../../../jss_setup";
import { StyleTypeContext } from "../../../umbilical_tools";
import { useNavBarGeneralHook } from "./hooks";
import { BannerBar } from "../../navbars/thehotelco";
import { ProfileBar } from "../../navbars/ubook";
import { publicPaths } from "../../../hooks/authentication";
import { TmdhLinks } from "../../navbars/tmdh";
import { ProductTypeSectionsLinks } from "../../navbars/ProductTypeSectionsLinks";
import { GenericSectionsLinks } from "../../navbars/GenericSectionsLinks";
import { LoginComp, MenuModal } from "./components";
import { InlineIcon } from "@iconify/react";
import LanguageSelector from "../../LanguageSelector";
import CurrencySelector from "../../CurrencySelector";
import { withAuth } from "../../../context";
import { Link, withRouter } from "react-router-dom";
import { ProfileHoc } from "../../../umbilical_hocs";
import { animateScroll as scroll } from "react-scroll";
import { PointsSmallWidget } from "../../widgets/PointsSmallWidget/index.jsx";

export var redirectUrl = import.meta.env.VITE_APP_AUTH_SUCCESS_REDIRECT;
const S3_URL = import.meta.env.VITE_APP_S3_ASSETS_URL;
const logo = import.meta.env.VITE_APP_LOGO;

const navBarStyles = createUseStyles({
  NavBar: (props) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: jssVariables.navbar_height,
    maxHeight: jssVariables.navbar_height,
    zIndex: 1083,
    transition: "background .5s",
    background:
      props.showNavbar && props.brand === "thehotelco"
        ? jssVariables.colors.background.dark
        : !props.showNavbar && props.brand === "thehotelco"
          ? "transparent"
          : jssVariables.colors.background.light,
    color: jssVariables.colors.darkTextColor,
    padding: [jssVariables.half_gap, jssVariables.normal_gap],
    boxShadow: jssVariables.shadows.normalShadow,
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    justifyContent: "space-between",
    alignItems: "center",
    ..._.get(props, "customStyles.NavBar", {}),
  }),
  backgroundImg: (props) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: jssVariables.navbar_height,
    zIndex: -1,
    objectFit: "cover",
    ..._.get(props, "customStyles.backgroundImg", {}),
  }),
  logo: (props) => ({
    height: `calc(${jssVariables.navbar_height} / 2)`,
    cursor: "pointer",
    objectFit: "contain",
    ..._.get(props, "customStyles.logo", {}),
  }),
  items: (props) => ({
    display: "none",
    ..._.get(props, "customStyles.items", {}),
  }),
  item: (props) => ({
    ..._.get(props, "customStyles.item", {}),
  }),
  customLink: (props) => ({
    ..._.get(props, "customStyles.customLink", {}),
  }),
  burgerBtn: (props) => ({
    ...mainMenuBtn,
    ..._.get(props, "customStyles.burgerBtn", {}),
  }),
  selectedItem: (props) => ({
    ..._.get(props, "customStyles.selectedItem", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    NavBar: (props) => ({
      gridTemplateColumns: "max-content 1fr",
      width: "100%",
      paddingRight: jssVariables.double_gap,
      ..._.get(props, "customStyles.NavBar.smallscreen", {}),
    }),
    burgerBtn: (props) => ({
      display: "none",
      ..._.get(props, "customStyles.burgerBtn.smallscreen", {}),
    }),
    items: (props) => ({
      display: "grid",
      gridAutoFlow: "column",
      gridAutoColumns: "max-content",
      justifyContent: "end",
      gridGap: jssVariables.double_gap,
      alignItems: "center",
      ..._.get(props, "customStyles.items.smallscreen", {}),
    }),
    item: (props) => ({
      fontWeight: "bold",
      textDecoration: "none",
      cursor: "pointer",
      color: jssVariables.colors.text.dark,
      "&:hover": {
        textDecoration: "none",
      },
      "&:visited": {
        textDecoration: "none",
      },
      "&:active": {
        textDecoration: "none",
      },
      "&:focus": {
        textDecoration: "none",
      },
      ..._.get(props, "customStyles.item.smallscreen", {}),
    }),
    selectedItem: (props) => ({
      fontWeight: "bold",
      ..._.get(props, "customStyles.selectedItem.smallscreen", {}),
    }),
    logo: (props) => ({
      ..._.get(props, "customStyles.logo.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    item: (props) => ({
      fontSize: "large",
      ..._.get(props, "customStyles.item.bigscreen", {}),
    }),
  },
});
let NavBar = () => {
  const [showMenuModal, setShowMenuModal] = useState(false);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [showNavbar, setShowNavbar] = useState(false);

  const {
    t,
    isInHomepage,
    isInHotelDetailsPageRocsBrand,
    currentPagePath,
    languages,
    multi_currency,
    home_btn_url,
    product_types,
    withLogin,
    withPoints,
    main_logo,
  } = useNavBarGeneralHook({ setShowNavbar });

  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({ type, brand, objName: "navbar" });

  const classes = navBarStyles({
    isInHomepage,
    isInHotelDetails: isInHotelDetailsPageRocsBrand,
    brand,
    showNavbar,
    customStyles,
  });

  const isInRoot = location.pathname === "/";

  return (
    <div className={classes.NavBar}>
      {brand === "easy" && (
        <img className={classes.backgroundImg} alt="logo" src={`${S3_URL}/top_menu_bg.svg`} />
      )}
      {brand === "thehotelco" && <BannerBar />}
      {home_btn_url === "/" ? (
        <Link
          className={`${classes.customLink} custom-link`}
          to={home_btn_url}
          onClick={() => scroll.scrollToTop()}
        >
          <img className={classes.logo} alt="logo" src={main_logo ?? logo} />
        </Link>
      ) : (
        <img
          className={classes.logo}
          alt="logo"
          src={logo}
          onClick={() =>
            !publicPaths.includes(currentPagePath) ? (window.location.href = home_btn_url) : {}
          }
        />
      )}
      {!publicPaths.includes(currentPagePath) && (
        <div className={classes.items}>
          {!["tmdh", "thehotelco"].includes(brand) &&
            (home_btn_url === "/" ? (
              <Link className={`${classes.item} ${isInRoot && classes.selectedItem}`} to="/">
                {t("home")}
              </Link>
            ) : (
              <a className={classes.item} href={home_btn_url} target="_blank" rel="noreferrer">
                {t("home")}
              </a>
            ))}
          <GenericSectionsLinks customStyles={customStyles} />
          <ProductTypeSectionsLinks customStyles={customStyles} />
          {withPoints && <PointsSmallWidget />}
          {languages.length > 1 && (
            <LanguageSelector
              languages={languages}
              customStyles={customStyles}
              showLanguageModal={showLanguageModal}
              setShowLanguageModal={setShowLanguageModal}
            />
          )}
          {multi_currency && (
            <CurrencySelector
              showCurrencyModal={showCurrencyModal}
              setShowCurrencyModal={setShowCurrencyModal}
            />
          )}
          {withLogin && <LoginComp customStyles={customStyles} />}
        </div>
      )}
      <button className={classes.burgerBtn} onClick={() => setShowMenuModal(true)}>
        <InlineIcon icon={brand === "rocs" ? "ooui:menu" : "ion:menu"} />
      </button>
      {showMenuModal && (
        <MenuModal
          languages={languages}
          home_btn_url={home_btn_url}
          customStyles={customStyles}
          product_types={product_types}
          withLogin={withLogin}
          multi_currency={multi_currency}
          showCurrencyModal={showCurrencyModal}
          showLanguageModal={showLanguageModal}
          closeModal={() => setShowMenuModal(false)}
          setShowLanguageModal={setShowLanguageModal}
          setShowCurrencyModal={setShowCurrencyModal}
        />
      )}
    </div>
  );
};
NavBar = ProfileHoc(withRouter(NavBar), withAuth);
export { NavBar };
